import { render } from "./PromoCodeManagerNew.vue?vue&type=template&id=11dd9667&scoped=true"
import script from "./PromoCodeManagerNew.vue?vue&type=script&lang=js"
export * from "./PromoCodeManagerNew.vue?vue&type=script&lang=js"

import "./PromoCodeManagerNew.vue?vue&type=style&index=0&id=11dd9667&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dd9667"]])

export default __exports__